import type { JSX } from 'react';

/**
 * Folded-ballot-leaf woodcut sigil for the "Another Round" sentinel cell —
 * a printer's-mark style seal (a sheet with a quill crossing it) drawn in the
 * project's 1.25–1.3px stroke woodcut language. `currentColor` so it inherits
 * the cell's POV-aware ink; the quill's fill reads `--page-plate` so it sits
 * as paper over the leaf rather than a solid block. aria-hidden — the cell's
 * own aria-label carries the meaning.
 */
export function BallotSigil(): JSX.Element {
  return (
    <svg viewBox="0 0 76 76" aria-hidden focusable={false} className="susdle-ballot-sigil">
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.3}
      >
        <path d="M 18 16 L 50 16 L 60 26 L 60 62 L 18 62 Z" />
        <path d="M 50 16 L 50 26 L 60 26" opacity="0.85" />
        <path d="M 25 34 L 45 34" opacity="0.6" />
        <path d="M 25 41 L 41 41" opacity="0.6" />
      </g>
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.25}
      >
        <path d="M 50 56 L 34 40 Q 30 36 33 33 Q 40 28 47 35 L 58 50 Z" fill="var(--page-plate)" />
        <path d="M 36 42 L 40 38" opacity="0.7" />
      </g>
    </svg>
  );
}
